import Avatar from '@/atoms/avatars/Avatar';
import Button from '@/atoms/buttons/Button';
import EntityChip from '@/atoms/chips/EntityChip';
import Paragraph from '@/atoms/typography/Paragraph';
import Size from '@enums/Size';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { core } from '@/lib/theme/tokens/palettes';

const HierarchyEntityCard = ({
  entityType,
  id,
  label,
  onClick,
  isActive,
  status,
  person,
}) => {
  const personName = person ? `${person.first_name} ${person.last_name}` : null;

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
  };

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-bewteen"
      spacing={2}
      pl={status.expandable ? 0.5 : 2}
      sx={{
        position: 'relative',
      }}
    >
      <Stack alignItems="center" direction="row" spacing={1}>
        {person && (
          <Avatar
            src={person.avatar}
            name={personName}
            sizeProps={{
              fontSize: '1rem',
              width: '30px',
              height: '30px',
            }}
          />
        )}
        <Box>
          <Stack
            alignItems="center"
            direction="row"
            spacing={0.5}
            mt={person ? 0.25 : 0}
          >
            <EntityChip type={entityType} size={Size.XX_SMALL} />
            {person && (
              <Paragraph
                size={Size.MEDIUM}
                overrideStyles={{
                  color: isActive ? core.white : 'inherit',
                  textShadow: isActive ? '0 1px 1px rgba(0,0,0,0.2)' : 'none',
                  mb: 0,
                  fontSize: '0.875rem',
                  lineHeight: '0.925rem',
                }}
              >
                {label}
              </Paragraph>
            )}
          </Stack>
          <Paragraph
            size={Size.SMALL}
            overrideStyles={{
              color: isActive ? core.white : 'inherit',
              mb: 0,
              mt: person ? 0.5 : 0.55,
              fontSize: person ? '0.725rem' : '0.875rem',
              lineHeight: person ? '0.725rem' : '0.875rem',
              textShadow: isActive ? '0 1px 1px rgba(0,0,0,0.2)' : 'none',
            }}
          >
            {personName ?? label}
          </Paragraph>
        </Box>
      </Stack>
      {!isActive && (
        <Box
          className="view-button"
          position="absolute"
          top={2.5}
          right={0}
          sx={{
            transition: 'opacity 200ms',
            opacity: 0,
            pointerEvents: 'none',
          }}
        >
          <Button
            boldText
            label="View"
            color="secondary"
            onClick={handleOnClick}
            size={Size.X_SMALL}
          />
        </Box>
      )}
    </Stack>
  );
};

export default HierarchyEntityCard;
